import { ListCourseProgressFilters } from '@/data/services/courseProgressServices';
import { CourseFormatEnum } from '@/models/Course';
import { FilterProps } from '@/models/FilterConfig';
import { useTranslation } from 'react-i18next';
import ToggleGroup, {
  ToggleButton,
} from '@/components/ui/custom/dataInput/ToggleGroup';
import Filter from '@/components/filter/Filter';

type CourseProgressFilterProps = {
  filter: CourseProgressFilter;
  onChange: (filter: CourseProgressFilter) => void;
};
type FormatsFilter =
  | Exclude<CourseFormatEnum, 'EXTRA_COURSE' | 'SELF_PACED'>
  | 'ALL'
  | 'ASYNC';
export type CourseProgressFilter = {
  courseFormats?: FormatsFilter;
} & Pick<ListCourseProgressFilters, 'search' | 'ordering'>;

export const CourseProgressFilters = ({
  filter,
  onChange,
}: CourseProgressFilterProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'coursesView.student.filters',
  });
  const [tFormats] = useTranslation('translation', {
    keyPrefix: 'courseFormats',
  });

  const config: FilterProps[] = [
    {
      type: 'select',
      name: 'ordering',
      label: t('ordering'),
      options: [
        { label: 'mais recente', value: 'created_at' },
        { label: 'mais antigo', value: '-created_at' },
      ],
    },
    {
      type: 'search',
      className: { input: 'w-80' },
      name: 'search',
      placeholder: t('search'),
      debounce: true,
      value: '',
    },
  ];

  const buttons: ToggleButton<FormatsFilter>[] = [
    {
      text: t('all'),
      value: 'ALL',
      className: {
        regular: 'border-accent text-accent enabled:hover:bg-accent-content',
        active: 'bg-accent border-accent',
      },
    },
    {
      text: tFormats(CourseFormatEnum.IN_PERSON),
      value: CourseFormatEnum.IN_PERSON,
      className: {
        regular: 'border-primary text-primary enabled:hover:bg-primary-content',
        active: 'bg-primary border-primary',
      },
    },
    {
      text: tFormats(CourseFormatEnum.ONLINE),
      value: CourseFormatEnum.ONLINE,
      className: {
        regular: 'border-primary text-primary enabled:hover:bg-primary-content',
        active: 'bg-primary border-primary',
      },
    },
    {
      text: tFormats(CourseFormatEnum.SCHOOL),
      value: CourseFormatEnum.SCHOOL,
      className: {
        regular: 'border-primary text-primary enabled:hover:bg-primary-content',
        active: 'bg-primary border-primary',
      },
    },
    {
      text: t('async'),
      value: 'ASYNC',
      className: {
        regular: 'border-info text-info enabled:hover:bg-info-content',
        active: 'bg-info border-info',
      },
    },
  ];
  return (
    <div className="flex gap-2.5 justify-between">
      <ToggleGroup
        buttons={buttons}
        exclusive
        value={filter.courseFormats || 'ALL'}
        className={{ button: 'lowercase' }}
        onChange={restrict => {
          onChange({ courseFormats: restrict });
        }}
      />
      <Filter
        configs={config}
        onChange={onChange}
        filter={filter}
        hideQuick
        className={{
          ul: 'justify-end',
        }}
      />
    </div>
  );
};
